import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8468a734"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "elections-wrapper col-md-12" }
const _hoisted_4 = {
  key: 0,
  id: "election-wrapper"
}
const _hoisted_5 = {
  class: "section-wrapper",
  style: {"width":"100%"}
}
const _hoisted_6 = { class: "election-name" }
const _hoisted_7 = { class: "election-name" }
const _hoisted_8 = { class: "name-box" }
const _hoisted_9 = { class: "election-info section-info-wrapper" }
const _hoisted_10 = {
  key: 0,
  class: "election-info section-info-wrapper"
}
const _hoisted_11 = { class: "row" }
const _hoisted_12 = {
  key: 0,
  id: "position-for-winner-table",
  class: "col-md-4"
}
const _hoisted_13 = { class: "election-info-tbl flat-table table" }
const _hoisted_14 = { class: "table-top-left election-rule" }
const _hoisted_15 = { class: "table-top-left election-rule-description" }
const _hoisted_16 = ["title"]
const _hoisted_17 = { class: "table-left election-rule-description change-to" }
const _hoisted_18 = { class: "change-to" }
const _hoisted_19 = {
  key: 1,
  class: "election-heading col-md-5"
}
const _hoisted_20 = { class: "election-action-on-complete" }
const _hoisted_21 = {
  class: "panel-group",
  id: "accordion"
}
const _hoisted_22 = { class: "panel-heading" }
const _hoisted_23 = { class: "panel-title" }
const _hoisted_24 = ["href"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "caret pull-right" }, null, -1))
const _hoisted_26 = ["id"]
const _hoisted_27 = { class: "panel-body" }
const _hoisted_28 = {
  class: "election-info-tbl flat-table table",
  style: {"table-layout":"fixed","width":"100%"}
}
const _hoisted_29 = {
  key: 0,
  class: "collapsible"
}
const _hoisted_30 = { class: "table-top-left election-rule" }
const _hoisted_31 = { class: "table-top-left election-rule-description" }
const _hoisted_32 = {
  key: 0,
  class: "table-top-left election-rule-description"
}
const _hoisted_33 = ["title"]
const _hoisted_34 = { class: "table-left change-to" }
const _hoisted_35 = { class: "change-to" }
const _hoisted_36 = {
  key: 0,
  class: "table-left current"
}
const _hoisted_37 = { class: "current" }
const _hoisted_38 = {
  key: 1,
  style: {"display":"table-row-group"}
}
const _hoisted_39 = { class: "table-top" }
const _hoisted_40 = {
  class: "table-top-left",
  style: {"text-align":"left"}
}
const _hoisted_41 = {
  key: 2,
  style: {"display":"table-row-group"}
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "table-top" }, [
  /*#__PURE__*/_createElementVNode("td", { class: "table-top-left" }, "No Data")
], -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = {
  key: 2,
  id: "candidates-results-wrapper",
  class: "col-md-5"
}
const _hoisted_45 = {
  class: "candidates-wrapper section-wrapper",
  id: "choise-election-wrapper"
}
const _hoisted_46 = {
  id: "choice-election-vote-wrapper",
  class: "voting-wrapper"
}
const _hoisted_47 = {
  key: 0,
  class: "vote"
}
const _hoisted_48 = {
  class: "add-self-wrapper",
  style: {"position":"relative"}
}
const _hoisted_49 = {
  key: 0,
  class: "btn-group btn-group-toggle bool-choice-controls vote-item vote-button",
  "data-toggle": "buttons"
}
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["value"]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "⇅", -1))
const _hoisted_53 = ["data-id"]
const _hoisted_54 = { class: "candidate-name-title" }
const _hoisted_55 = { class: "candidate-speech" }
const _hoisted_56 = {
  key: 0,
  id: "ranked-election-vote-wrapper",
  class: "voting-wrapper"
}
const _hoisted_57 = {
  id: "section-title",
  "data-toggle": "tooltip",
  "data-container": "body",
  "data-placement": "left",
  "data-original-title": "Click and drag the candidates to put them in your order of preference. If your first choice\r\n                                                            doesn't have enough votes to win, your second choice will be used, etc."
}
const _hoisted_58 = {
  style: {"width":"100%"},
  class: "localize"
}
const _hoisted_59 = {
  key: 0,
  class: "vote"
}
const _hoisted_60 = {
  class: "add-self-wrapper",
  style: {"position":"relative"}
}
const _hoisted_61 = {
  key: 0,
  class: "vote-drag-box"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "⇅", -1))
const _hoisted_63 = { class: "choice" }
const _hoisted_64 = ["data-id"]
const _hoisted_65 = { class: "candidate-name-title" }
const _hoisted_66 = { class: "candidate-speech" }
const _hoisted_67 = { class: "localize" }
const _hoisted_68 = { class: "voted-wrapper col-md-8" }
const _hoisted_69 = {
  key: 0,
  class: "votes-per-round multi-choice-election"
}
const _hoisted_70 = {
  key: 0,
  class: "no-votes"
}
const _hoisted_71 = { class: "localize" }
const _hoisted_72 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_73 = {
  key: 1,
  class: "flat-table table",
  style: {"text-align":"center"}
}
const _hoisted_74 = { class: "title-heading" }
const _hoisted_75 = { class: "th" }
const _hoisted_76 = { class: "localize" }
const _hoisted_77 = { class: "table-top" }
const _hoisted_78 = { class: "table-top-left" }
const _hoisted_79 = { class: "localize" }
const _hoisted_80 = { class: "localize" }
const _hoisted_81 = ["innerHTML"]
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_83 = { key: 0 }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_85 = { key: 1 }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_87 = { class: "table-bottom" }
const _hoisted_88 = { class: "localize" }
const _hoisted_89 = {
  key: 1,
  id: "votingResultsChart",
  class: "votes-per-round"
}
const _hoisted_90 = { class: "election-info-wrapper col-md-8" }
const _hoisted_91 = {
  id: "election-info-results-wrapper",
  class: "election-info section-info-wrapper"
}
const _hoisted_92 = { key: 0 }
const _hoisted_93 = { class: "localize" }
const _hoisted_94 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_95 = ["innerHTML"]
const _hoisted_96 = { class: "localize" }
const _hoisted_97 = { key: 1 }
const _hoisted_98 = { class: "localize" }
const _hoisted_99 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_100 = ["innerHTML"]
const _hoisted_101 = { class: "localize" }
const _hoisted_102 = { key: 2 }
const _hoisted_103 = { class: "localize" }
const _hoisted_104 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_105 = ["innerHTML"]
const _hoisted_106 = { key: 3 }
const _hoisted_107 = {
  key: 0,
  class: "localize"
}
const _hoisted_108 = {
  key: 1,
  class: "localize"
}
const _hoisted_109 = { class: "localize" }
const _hoisted_110 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_111 = { key: 4 }
const _hoisted_112 = {
  key: 0,
  class: "localize"
}
const _hoisted_113 = {
  key: 1,
  class: "localize"
}
const _hoisted_114 = { class: "localize" }
const _hoisted_115 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_116 = { key: 5 }
const _hoisted_117 = {
  key: 0,
  class: "localize"
}
const _hoisted_118 = {
  key: 1,
  class: "localize"
}
const _hoisted_119 = { class: "localize" }
const _hoisted_120 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_121 = { key: 6 }
const _hoisted_122 = /*#__PURE__*/_createTextVNode(" This election is conducted with Instant Runoff Voting. This means that if a citizen's first choice candidate doesn't have enough votes to win, their vote goes instead to their second choice candidate, then third choice, and so on. This table shows each round of removal and how many votes each candidate has. For more info, see ")
const _hoisted_123 = {
  href: "https://en.wikipedia.org/wiki/Instant%E2%80%90runoff_voting",
  target: "_blank",
  class: "localize"
}
const _hoisted_124 = { class: "localize" }
const _hoisted_125 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  id: "candidate-names"
}, null, -1))
const _hoisted_127 = { class: "election-discussion section-wrapper" }
const _hoisted_128 = { class: "section-wrapper-2" }
const _hoisted_129 = {
  key: 0,
  class: "discussion-user"
}
const _hoisted_130 = { class: "law-discussion-wrapper" }
const _hoisted_131 = { class: "law-discussion-user" }
const _hoisted_132 = ["innerHTML"]
const _hoisted_133 = {
  key: 0,
  class: "law-discussion-comment"
}
const _hoisted_134 = { key: 1 }
const _hoisted_135 = ["placeholder"]
const _hoisted_136 = { class: "add-comment-buttons" }
const _hoisted_137 = ["disabled"]
const _hoisted_138 = { class: "localize" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "law-add-graph",
  style: {"display":"inline-block"}
}, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "hidden",
    id: "graph-data",
    value: ""
  })
], -1))
const _hoisted_140 = {
  class: "edit-comment-buttons",
  style: {"display":"none"}
}
const _hoisted_141 = {
  id: "cancel-edit",
  class: "eco-button"
}
const _hoisted_142 = { class: "localize" }
const _hoisted_143 = ["disabled"]
const _hoisted_144 = { class: "localize" }
const _hoisted_145 = {
  class: "row",
  style: {"clear":"both","margin-right":"0"}
}
const _hoisted_146 = {
  key: 0,
  class: "comment-graph",
  id: "graph_composer",
  style: {"height":"536px"},
  src: "/graph_composer/index.html"
}
const _hoisted_147 = {
  key: 1,
  class: "map-wrapper-1 col-xl-4",
  id: "map-control-wrapper"
}
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "graphContainer",
  class: "election-wrapper-right col-xl-8 col-lg-12"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TMPLabel = _resolveComponent("TMPLabel")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_ElectionProcessModal = _resolveComponent("ElectionProcessModal")!
  const _component_AllVotesModal = _resolveComponent("AllVotesModal")!
  const _component_WorldMap = _resolveComponent("WorldMap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.election.Name)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("h2", null, [
                      _createElementVNode("span", _hoisted_8, [
                        _createVNode(_component_TMPLabel, {
                          class: "election-name-title",
                          text: _ctx.election.Name
                        }, null, 8, ["text"])
                      ])
                    ]),
                    _createElementVNode("span", _hoisted_9, [
                      _createVNode(_component_TMPLabel, {
                        class: "election-name-description",
                        text: _ctx.election.ElectionDescription,
                        onTmpLinkClick: _ctx.handleTMPLinkClick
                      }, null, 8, ["text", "onTmpLinkClick"])
                    ]),
                    (_ctx.election.Finished)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                          _createVNode(_component_TMPLabel, {
                            class: "election-name-description",
                            text: _ctx.election.Results.Result,
                            onTmpLinkClick: _ctx.handleTMPLinkClick
                          }, null, 8, ["text", "onTmpLinkClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                (_ctx.election.PositionForWinner)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("table", _hoisted_13, [
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.election.PositionForWinner.Table.slice(0, 1), (row, i) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: `candidateHead${i}`,
                              class: "table-top"
                            }, [
                              _createElementVNode("td", _hoisted_14, _toDisplayString(row[0]), 1),
                              _createElementVNode("td", _hoisted_15, _toDisplayString(row[2]), 1)
                            ]))
                          }), 128)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.election.PositionForWinner.Table.slice(1), (row, i) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: `candidateRow${i}`,
                              class: "table-middle"
                            }, [
                              _createElementVNode("td", {
                                class: "table-left election-rule",
                                "data-toggle": "tooltip",
                                "data-container": "body",
                                "data-placement": "left",
                                title: row[1]
                              }, _toDisplayString(row[0]), 9, _hoisted_16),
                              _createElementVNode("td", _hoisted_17, [
                                _createElementVNode("span", _hoisted_18, _toDisplayString(row[2]), 1)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.election.Provisions?.length ?? 0 > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.election.Provisions, (provision, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `provision${i}`,
                              class: "panel panel-default"
                            }, [
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("h4", _hoisted_23, [
                                  _createElementVNode("a", {
                                    "data-toggle": "collapse",
                                    "data-parent": "#accordion",
                                    href: `#provisionBody${i}`
                                  }, [
                                    _createVNode(_component_TMPLabel, {
                                      text: provision.ActionOnCompleteTableHeader || `Provision #${i + 1}`
                                    }, null, 8, ["text"]),
                                    _hoisted_25
                                  ], 8, _hoisted_24)
                                ])
                              ]),
                              _createElementVNode("div", {
                                id: `provisionBody${i}`,
                                class: _normalizeClass(`panel-collapse collapse ${!i ? 'in' : ''}`)
                              }, [
                                _createElementVNode("div", _hoisted_27, [
                                  _createElementVNode("table", _hoisted_28, [
                                    (provision.ActionOnCompleteTable)
                                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_29, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(provision.ActionOnCompleteTable.slice(0, 1), (row, j) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                              key: `actionHead${j}`,
                                              class: "table-top"
                                            }, [
                                              _createElementVNode("td", _hoisted_30, _toDisplayString(row[0]), 1),
                                              _createElementVNode("td", _hoisted_31, _toDisplayString(row[2]), 1),
                                              (row[3] !== undefined)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_32, _toDisplayString(row[3]), 1))
                                                : _createCommentVNode("", true)
                                            ]))
                                          }), 128)),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(provision.ActionOnCompleteTable.slice(1), (row, j) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                              key: `action${j}`,
                                              class: "table-middle"
                                            }, [
                                              _createElementVNode("td", {
                                                class: "table-left election-rule",
                                                "data-toggle": "tooltip",
                                                "data-container": "body",
                                                "data-placement": "left",
                                                title: row[1]
                                              }, _toDisplayString(row[0]), 9, _hoisted_33),
                                              _createElementVNode("td", _hoisted_34, [
                                                _createElementVNode("span", _hoisted_35, _toDisplayString(row[2]), 1)
                                              ]),
                                              (row[3] !== undefined)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_36, [
                                                    _createElementVNode("span", _hoisted_37, _toDisplayString(row[3]), 1)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          }), 128))
                                        ]))
                                      : (provision.ActionOnCompleteFullDescription)
                                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_38, [
                                            _createElementVNode("tr", _hoisted_39, [
                                              _createElementVNode("td", _hoisted_40, [
                                                _createVNode(_component_TMPLabel, {
                                                  text: provision.ActionOnCompleteFullDescription
                                                }, null, 8, ["text"])
                                              ])
                                            ])
                                          ]))
                                        : (_openBlock(), _createElementBlock("tbody", _hoisted_41, _hoisted_43))
                                  ])
                                ])
                              ], 10, _hoisted_26)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.election.Finished)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          (_ctx.store.username)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                _createElementVNode("div", _hoisted_48, [
                                  (_ctx.election.BooleanElection)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.election.Choices, (choice, i) => {
                                          return (_openBlock(), _createElementBlock("label", {
                                            key: `choice${i}`,
                                            onClick: _withModifiers(($event: any) => (_ctx.vote(choice.Id)), ["prevent"]),
                                            class: "btn btn-success form-check-label bool-choice-control eco-button"
                                          }, [
                                            _createElementVNode("input", {
                                              class: "form-check-input boolean-choice-input",
                                              type: "radio",
                                              name: "options",
                                              value: choice.Name
                                            }, null, 8, _hoisted_51),
                                            _createTextVNode(" " + _toDisplayString(choice.Name), 1)
                                          ], 8, _hoisted_50))
                                        }), 128))
                                      ]))
                                    : (_openBlock(), _createBlock(_component_draggable, {
                                        key: 1,
                                        modelValue: _ctx.candidates,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.candidates) = $event)),
                                        "item-key": "Id",
                                        group: { name: 'candidates' }
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.candidates, (candidate, i) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: `candidate${i}`,
                                              class: "vote-item grab"
                                            }, [
                                              _hoisted_52,
                                              _createElementVNode("p", {
                                                "data-id": candidate.Id,
                                                class: "candidate-name"
                                              }, [
                                                _createElementVNode("span", _hoisted_54, _toDisplayString(candidate.Name), 1),
                                                _createElementVNode("span", _hoisted_55, _toDisplayString(candidate.Speech), 1)
                                              ], 8, _hoisted_53)
                                            ]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"]))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (!_ctx.election.BooleanElection)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.$t("Candidates Ranked")), 1)
                              ]),
                              (_ctx.store.username)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                    _createElementVNode("div", _hoisted_60, [
                                      _createVNode(_component_draggable, {
                                        modelValue: _ctx.rankedCandidates,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.rankedCandidates) = $event)),
                                        "item-key": "Id",
                                        "ghost-class": "vote-drag-box",
                                        filter: ".vote-drag-box",
                                        group: { name: 'candidates' },
                                        onAdd: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changed = true)),
                                        onSort: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changed = true))
                                      }, {
                                        default: _withCtx(() => [
                                          (!_ctx.rankedCandidates.length)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_61, "Drag candidates here to vote"))
                                            : _createCommentVNode("", true),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rankedCandidates, (candidate, i) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: `rankedCandidate${i}`,
                                              class: "vote-item grab"
                                            }, [
                                              _hoisted_62,
                                              _createElementVNode("div", _hoisted_63, [
                                                _createElementVNode("span", null, _toDisplayString(++i), 1)
                                              ]),
                                              candidate
                                                ? (_openBlock(), _createElementBlock("p", {
                                                    key: 0,
                                                    "data-id": candidate.Id,
                                                    class: "candidate-name"
                                                  }, [
                                                    _createElementVNode("span", _hoisted_65, _toDisplayString(candidate.Name), 1),
                                                    _createElementVNode("span", _hoisted_66, _toDisplayString(candidate.Speech), 1)
                                                  ], 8, _hoisted_64))
                                                : _createCommentVNode("", true)
                                            ]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"]),
                                      (_ctx.rankedCandidates.length && _ctx.changed)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "eco-button vote-button",
                                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.vote && _ctx.vote(...args)))
                                          }, [
                                            _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.$t("Submit Vote")), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_68, [
                  (!_ctx.election.BooleanElection)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                        (!_ctx.election.TotalVotes)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_70, [
                              _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.$t("No one has voted yet")), 1),
                              _hoisted_72
                            ]))
                          : (_ctx.rounds.length)
                            ? (_openBlock(), _createElementBlock("table", _hoisted_73, [
                                _createElementVNode("thead", null, [
                                  _createElementVNode("tr", _hoisted_74, [
                                    _createElementVNode("td", _hoisted_75, [
                                      _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.$t("Votes per round")), 1)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("tbody", null, [
                                  _createElementVNode("tr", _hoisted_77, [
                                    _createElementVNode("td", _hoisted_78, [
                                      _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.$t("Candidates")), 1)
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rounds, (round, i) => {
                                      return (_openBlock(), _createElementBlock("td", {
                                        key: `roundHead${i}`
                                      }, [
                                        _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.$t("Round")), 1),
                                        _createTextVNode(" " + _toDisplayString(++i), 1)
                                      ]))
                                    }), 128))
                                  ]),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.election.Results?.ChoiceRanks, (candidate, i) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: `candVote${i}`,
                                      class: "table-middle table-alternating-color-1",
                                      "data-candidate": "48"
                                    }, [
                                      _createElementVNode("td", {
                                        class: "table-left",
                                        innerHTML: candidate.MarkedUpNameString
                                      }, null, 8, _hoisted_81),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(candidate.VotesPerRound, (vote, j) => {
                                        return (_openBlock(), _createElementBlock("td", {
                                          key: `roundVote${j}`,
                                          class: "round-vote"
                                        }, [
                                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("UserVotes")) + ": " + _toDisplayString(vote.UserVotes), 1),
                                          _hoisted_82,
                                          (vote.TwitchVotes!)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_83, _toDisplayString(_ctx.$t("TwitchVotes")) + ": " + _toDisplayString(Math.round(vote.TwitchVotes* 100) / 100), 1))
                                            : _createCommentVNode("", true),
                                          _hoisted_84,
                                          (vote.Total)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_85, _toDisplayString(_ctx.$t("Total")) + ": " + _toDisplayString(Math.round(vote.Total * 100) / 100), 1))
                                            : _createCommentVNode("", true),
                                          _hoisted_86
                                        ]))
                                      }), 128))
                                    ]))
                                  }), 128)),
                                  _createElementVNode("tr", _hoisted_87, [
                                    _createElementVNode("td", null, [
                                      _createElementVNode("span", _hoisted_88, _toDisplayString(_ctx.$t("Total")), 1)
                                    ]),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.totalAllVotes), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.election.BooleanElection && _ctx.election.TotalVotes)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_89))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_90, [
                  _createElementVNode("ul", _hoisted_91, [
                    (_ctx.election.Finished)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_92, [
                          _createElementVNode("span", _hoisted_93, _toDisplayString(_ctx.$t("Ended")), 1),
                          _hoisted_94,
                          _createElementVNode("span", { innerHTML: _ctx.timeEndAgo }, null, 8, _hoisted_95),
                          _createElementVNode("span", _hoisted_96, _toDisplayString(_ctx.$t("ago")), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("li", _hoisted_97, [
                          _createElementVNode("span", _hoisted_98, _toDisplayString(_ctx.$t("Since")), 1),
                          _hoisted_99,
                          _createElementVNode("span", { innerHTML: _ctx.timeStartAgo }, null, 8, _hoisted_100),
                          _createElementVNode("span", _hoisted_101, _toDisplayString(_ctx.$t("ago")), 1)
                        ])),
                    (!_ctx.election.Finished)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_102, [
                          _createElementVNode("span", _hoisted_103, _toDisplayString(_ctx.$t("Voting will end in")), 1),
                          _hoisted_104,
                          _createElementVNode("span", { innerHTML: _ctx.timeToElectionEnd }, null, 8, _hoisted_105)
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.election.Finished)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_106, [
                          _createTextVNode(_toDisplayString(_ctx.totalAllVotes) + " ", 1),
                          (_ctx.totalAllVotes == 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_107, _toDisplayString(_ctx.$t("Vote")), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_108, _toDisplayString(_ctx.$t("Votes")), 1)),
                          _createElementVNode("span", _hoisted_109, " " + _toDisplayString(_ctx.$t("Total")), 1),
                          _hoisted_110
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.election.Finished && _ctx.totalTwitchVotes > 0)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_111, [
                          _createTextVNode(_toDisplayString(_ctx.totalUserVotes) + " ", 1),
                          (_ctx.totalUserVotes == 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_112, _toDisplayString(_ctx.$t("Vote")), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_113, _toDisplayString(_ctx.$t("UserVotes")), 1)),
                          _createElementVNode("span", _hoisted_114, " " + _toDisplayString(_ctx.$t("Total")), 1),
                          _hoisted_115
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.election.Finished && _ctx.totalTwitchVotes > 0)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_116, [
                          _createTextVNode(_toDisplayString(_ctx.totalTwitchVotes) + " ", 1),
                          (_ctx.totalTwitchVotes== 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_117, _toDisplayString(_ctx.$t("Vote")), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_118, _toDisplayString(_ctx.$t("TwitchVotes")), 1)),
                          _createElementVNode("span", _hoisted_119, " " + _toDisplayString(_ctx.$t("Total")), 1),
                          _hoisted_120
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.election.BooleanElection)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_121, [
                          _hoisted_122,
                          _createElementVNode("a", _hoisted_123, _toDisplayString(_ctx.$t("Instant Runoff Voting")), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("li", null, [
                      _createVNode(_component_ElectionProcessModal, {
                        modelValue: _ctx.showElectionProcessModal,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showElectionProcessModal) = $event)),
                        election: _ctx.election
                      }, null, 8, ["modelValue", "election"]),
                      _createElementVNode("span", _hoisted_124, _toDisplayString(_ctx.$t("This election is conducted using the rules of ")), 1),
                      _createElementVNode("a", {
                        href: "#",
                        class: "election-process-info",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showElectionProcessModal = true)),
                        style: {"text-decoration":"none"}
                      }, _toDisplayString(_ctx.election.ElectionProcess.Name), 1),
                      _hoisted_125
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_AllVotesModal, {
                        modelValue: _ctx.showAllVotes,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showAllVotes) = $event)),
                        election: _ctx.election,
                        votes: _ctx.userVotesData
                      }, null, 8, ["modelValue", "election", "votes"]),
                      _createElementVNode("span", {
                        class: "view-all-votes localize",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showAllVotes = true))
                      }, _toDisplayString(_ctx.$t("View All Votes")), 1)
                    ])
                  ])
                ]),
                _hoisted_126
              ]),
              _createElementVNode("div", _hoisted_127, [
                _createElementVNode("div", _hoisted_128, [
                  (_ctx.election.Comments.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                        _createElementVNode("div", _hoisted_130, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.election.Comments, (comment, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `comment${i}`,
                              class: "comment-section1"
                            }, [
                              _createElementVNode("div", _hoisted_131, [
                                _createTextVNode(_toDisplayString(comment.Username) + " ", 1),
                                _createElementVNode("span", {
                                  class: "law-discussion-time",
                                  innerHTML: `Posted on ${_ctx.sec2worldTime(comment.Timestamp)}`
                                }, null, 8, _hoisted_132)
                              ]),
                              (comment.Text)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_133, _toDisplayString(comment.Text), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.election.Finished)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                        _withDirectives(_createElementVNode("textarea", {
                          id: "comment",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.commentText) = $event)),
                          class: "election-comment form-control localize",
                          placeholder: _ctx.$t('Enter your response')
                        }, null, 8, _hoisted_135), [
                          [_vModelText, _ctx.commentText]
                        ]),
                        _createElementVNode("div", _hoisted_136, [
                          _createElementVNode("button", {
                            id: "addGraph",
                            class: "fa fa-bar-chart comment-button add-graph-button",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showGraphComposer=!_ctx.showGraphComposer))
                          }),
                          _createElementVNode("button", {
                            class: "fa fa-globe comment-button add-map-button",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showWorldMap=!_ctx.showWorldMap))
                          }),
                          _createElementVNode("button", {
                            id: "pushComment",
                            disabled: !this.commentText,
                            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.comment && _ctx.comment(...args))),
                            class: "eco-button"
                          }, [
                            _createElementVNode("span", _hoisted_138, _toDisplayString(_ctx.$t("Submit")), 1)
                          ], 8, _hoisted_137),
                          _hoisted_139
                        ]),
                        _createElementVNode("div", _hoisted_140, [
                          _createElementVNode("button", _hoisted_141, [
                            _createElementVNode("span", _hoisted_142, _toDisplayString(_ctx.$t("Cancel")), 1)
                          ]),
                          _createElementVNode("button", {
                            id: "submit",
                            disabled: !this.commentText,
                            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.comment && _ctx.comment(...args))),
                            class: "eco-button",
                            style: {"display":"block"}
                          }, [
                            _createElementVNode("span", _hoisted_144, _toDisplayString(_ctx.$t("Submit")), 1)
                          ], 8, _hoisted_143)
                        ]),
                        _createElementVNode("div", _hoisted_145, [
                          (_ctx.showGraphComposer)
                            ? (_openBlock(), _createElementBlock("iframe", _hoisted_146))
                            : _createCommentVNode("", true),
                          (_ctx.showWorldMap)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                                _createVNode(_component_WorldMap)
                              ]))
                            : _createCommentVNode("", true),
                          _hoisted_148
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}